/* Total Eyewear — Rx dropdown inputs (v8, 25 Sep 2026).
   Replaces the wizard's six free-text SPH/CYL/AXIS fields with <select>
   dropdowns so extreme or malformed eye-test results cannot be entered.
   RANGES (matched to the lab's Lite STOCK single-vision list, Jan 2025):
   SPH +6.00 → −10.00 in 0.25 steps · CYL ±4.00 in 0.25 steps (per-lens
   limits in the wizard enforce tighter caps) · AXIS 1–180 whole degrees.
   Stronger powers → “contact our specialists” note. PD keeps free entry +
   camera tool (dual-PD formats like 31/31).
   v5: demo-lens disclosure now names ESSILOR — lenses are the Essilor Lite
   range (Daneev 4 Jul: “technically Essilor lenses”), stated truthfully.
   v6: “genuine” dropped from Essilor wording (Daneev: reads try-hard).
   v8 (25 Sep 2026, Daneev): SPH and CYL lists now OPEN ON 0.00 / None —
   0.00 sits in the middle of the list and is pre-selected, so customers
   scroll up for plus powers and down for minus powers (a blank SPH was
   always read as 0.00 by the wizard, so behaviour is unchanged).
   The Essilor demo-lens note is NOT shown on Ray-Ban Meta products (those
   lenses are Ray-Ban Authentic, made by Ray-Ban). Wording: no “prescription”,
   no “genuine”.
   ⚠️ brief §8 gate: confirm contractual right to use the Essilor name in
   marketing.
   Runs deferred BEFORE DOMContentLoaded so the wizard's init() binds to the
   selects; selects fire 'input' on change, which the wizard listens for.
   Ranges: SPH_MAX/SPH_MIN/CYL_MAX. */
(function () {
  var SPH_MAX = 6, SPH_MIN = -10, CYL_MAX = 4;
  function fmt(v) {
    var s = v.toFixed(2);
    return v > 0 ? '+' + s : s;
  }
  function q(v) { return Math.round(v * 4) / 4; }
  /* SPH: plus powers, then 0.00 (pre-selected), then minus powers */
  function sphOptions() {
    var out = [];
    for (var v = SPH_MAX; v >= 0.25 - 0.001; v -= 0.25) out.push([fmt(q(v)), fmt(q(v))]);
    out.push(['0.00', '0.00', true]);
    for (var w = -0.25; w >= SPH_MIN - 0.001; w -= 0.25) out.push([fmt(q(w)), fmt(q(w))]);
    return out;
  }
  /* CYL: plus values, then None (pre-selected), then minus values */
  function cylOptions() {
    var out = [];
    for (var v = CYL_MAX; v >= 0.25 - 0.001; v -= 0.25) out.push([fmt(q(v)), fmt(q(v))]);
    out.push(['', 'None', true]);
    for (var w = -0.25; w >= -CYL_MAX - 0.001; w -= 0.25) out.push([fmt(q(w)), fmt(q(w))]);
    return out;
  }
  function axisOptions() {
    var out = [['', '—', true]];
    for (var i = 1; i <= 180; i++) out.push([String(i), String(i)]);
    return out;
  }
  var LISTS = { sph: sphOptions(), cyl: cylOptions(), axis: axisOptions() };

  function kindOf(el) {
    var k = el.getAttribute('data-rx') || '';
    if (/-sph$/.test(k)) return 'sph';
    if (/-cyl$/.test(k)) return 'cyl';
    if (/-axis$/.test(k)) return 'axis';
    return null;
  }

  function swap(el) {
    var kind = kindOf(el);
    if (!kind || el.tagName === 'SELECT') return;
    var sel = document.createElement('select');
    ['data-rx', 'data-rx-field', 'aria-label'].forEach(function (a) {
      var v = el.getAttribute(a);
      if (v) sel.setAttribute(a, v);
    });
    sel.className = 'rxsg-select';
    /* hidden blank option so the wizard can clear the field (e.g. non-powered tick box) */
    var opts = kind === 'sph' ? '<option value="" hidden>Select…</option>' : '';
    var list = LISTS[kind];
    for (var i = 0; i < list.length; i++) {
      opts += '<option value="' + list[i][0] + '"' + (list[i][2] ? ' selected' : '') + '>' + list[i][1] + '</option>';
    }
    sel.innerHTML = opts;
    el.parentNode.replaceChild(sel, el);
  }

  function isMeta() {
    var root = document.querySelector('.prescription-addon');
    return !!(root && root.getAttribute('data-te-meta') === '1');
  }

  function addNote() {
    var table = document.querySelector('.prescription-addon .rx-table');
    if (!table || document.querySelector('.rxsg-note')) return;
    var p = document.createElement('p');
    p.className = 'rxw-help rxsg-note';
    p.style.margin = '0 0 14px';
    p.innerHTML = 'The lists open at 0.00 &mdash; scroll up for plus (+) powers and down for minus (&minus;) powers. Stronger lens powers than these? We can often still help &mdash; <a href="/pages/contact">contact our specialist team</a> for a personal quote.';
    table.parentNode.insertBefore(p, table.nextSibling);
  }

  function addDemoLensNote() {
    if (isMeta()) return;
    var notice = document.querySelector('.prescription-addon .rx-notice');
    if (!notice || notice.querySelector('.rxsg-demolens')) return;
    var s = document.createElement('span');
    s.className = 'rxsg-demolens';
    s.innerHTML = '&#128295; Your new lenses are made by <strong>Essilor</strong>, the world’s leading lens maker, to your exact eye-test results and fitted by our specialist glazing lab. They replace the lenses supplied with the frame — including any branded demo or sunglass lenses — so logos etched on the original lenses (Ray-Ban, Oakley and others) won’t appear on your new lenses. The frame itself is unchanged.';
    notice.appendChild(s);
  }

  function boot() {
    var fields = document.querySelectorAll('.prescription-addon [data-rx]');
    if (!fields.length) return;
    if (!document.getElementById('rxsg-css')) {
      var css = document.createElement('style');
      css.id = 'rxsg-css';
      css.textContent = '.rx-table select.rxsg-select{width:100%;border:1px solid #e8e4df;border-radius:3px;padding:8px 4px;font-size:0.8rem;text-align:center;color:#1a1a1a;background:#fafaf9;box-sizing:border-box;}.rx-table select.rxsg-select:focus{outline:2px solid #1c2b3a;outline-offset:1px;background:#fff;}';
      document.head.appendChild(css);
    }
    for (var i = 0; i < fields.length; i++) swap(fields[i]);
    addNote();
    addDemoLensNote();
  }

  /* Deferred scripts run before DOMContentLoaded, so this executes ahead of
     the wizard's init() listener. Run immediately; fall back if needed. */
  boot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();

/* v7 review-step display patch retired in v8 — the wizard (v8) now prints the
   raw SPH/CYL values in the summary itself. */
